<template>
     <div class="site-view">
      <Header :title="Title"/>
        <section class="page-section darken" id="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div class="text-wrap">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>BRT Phase 2</b></p>
                                <h1 class="">Overview</h1>
                            </div>
                        </div>
                         <VerticalTab :data="veticalTabData" :colorStyle="colorCodeDark"/>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        
                        <TextSlider :carousel="sliderData.carousel"/>
                    </div>
                    
                </div>
            </div>
        </section>
        <a name="glider-section"></a>
        <section class="page-section dark-blue-bg" id="glider-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div  class="align-col-center">
                            <img src="@/assets/images/Belfast/PagePhase/glider.png">
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div class="text-wrap">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>BRT Phase 2</b></p>
                                <h1 class="light">What is Glider?</h1>
                                <p>Glider is the brand name for the Department for Infrastructure's Belfast Rapid Transit (BRT) system which came into operation in West Belfast, East Belfast and the Titanic Quarter in September 2018.</p>

                                <p>The introduction of Glider brought about a new, innovative mode of travel for Belfast which enhanced the image of the City and resulted in significant increases in patronage levels along the BRT corridors. It continues to be a key element in the delivery of the draft Programme for Government.</p>

                                <p>The introduction of Glider has provided a modern, safe, accessible, efficient and high quality public transport service which has encouraged more people to travel by public transport instead of the private car. Glider has helped to support sustainable economic growth and regeneration, and has helped to integrate communities though linking people to jobs, shops, lesiure, health and educational services.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="page-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>BRT Phase 2</b></p>
                                <h1>BRT Characteristics</h1>
                            </div>
                        </div>
                        <!-- <HorizontalTab/> -->
                        <HorizontalTabNew/>
                    </div>
                </div>
            </div>
        </section>
        
        <a name="timeline-section"></a>
        <section class="page-section timeline-bg" id="timeline-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-wrap center-align">
                            <div class="">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>BRT Phase 2</b></p>
                                <h1 class="light">BRT Phase Two Timeline</h1>
                                <!-- <p>Here is a history of changes throughout the process of BRT Phase 2.</p> -->
                            </div>
                        </div>
                        <section class="hide-on-small-and-down show-on-medium-and-up">
                            <div class="container">
                                <div class="timeline">
                                     <img src="@/assets/images/Belfast/Timeline/timeline.png" style="width:100%;">
                                </div>
                            </div>
                        </section>
                       
                        <section class="show-on-med-and-down hide-on-med-and-up">
                            <div class="container">
                                <div class="timeline">
                                     <img src="@/assets/images/Belfast/Timeline/timeline-mobile.png" style="width:100%;" class="mobile-timeline-image">
                                </div>
                            </div>
                        </section>
                        <!-- <Timeline/> -->
                    </div>
                </div>
            </div>
        </section>
        <a name="next-steps-section"></a>
        <section class="page-section" id="next-steps-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div class="text-wrap">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>BRT Phase 2</b></p>
                                <h1>Next Steps</h1>
                            </div>
                        </div>
                         <VerticalTab :data="veticalTabData2" :colorStyle="colorCodeDark"/>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div  class="align-col-center">
                            <img src="@/assets/images/Belfast/PagePhase/audi.png">
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <TwoColumnFooter/>
        <Footer />
    </div>
</template>

<script>

import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";
import Timeline from "@/components/belfast/Timeline";
import HorizontalTab from "@/components/belfast/HorizontalTab";
import HorizontalTabNew from "@/components/belfast/HorizontalTabNew";
import VerticalTab from "@/components/belfast/VerticalTab";
import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/HeroHeaderOtherPages";
import TextSlider from "@/components/belfast/TextSlider";
export default {
  name: "page-glider-phase",
   components: {
    Header,
    Footer,
    HorizontalTab,
    HorizontalTabNew,
    TwoColumnFooter,
    Timeline,
    VerticalTab,
    TextSlider
  },
  mounted(){
    if(this.$route.params.jumpTo){
        location.hash = "#" + this.$route.params.jumpTo;
    }
  },
  data() {
    return {
       Title:"BRT Phase 2",
       colorCodeLight:'light',
       colorCodeDark:'dark',
       veticalTabData: [
           
            {
                title:"Background",
                text: "The Belfast Rapid Transit Phase 1 (BRT1) pilot route network and service opened on 3rd September 2018 under the Glider brand and provides a rapid transit service between East and West Belfast through the City Centre, with a link to Titanic Quarter. The Glider largely replaced the Metro bus service on the Falls Road and Upper Newtownards Road corridors." 
            },
            {
                title:"BRT Phase 2",
                text: "<p>The Department for Infrastructure identified the potential to further extend the Belfast Rapid Transit network to North and South Belfast, Lisburn and Castlereagh City Council and Antrim and Newtownabbey Borough Council areas. In addition, the existing Glider G2 route (which currently serves Titanic Quarter) will also be extended to link with Queen’s University and Belfast City Hospital. The project is referred to as Belfast Rapid Transit Phase 2 (BRT2).</p>"
            }
        ],
        veticalTabData2: [
            {
                title:"Further Investigation of Route Options",
                text: "The responses to this consultation will be an important step in determining the preferred route options for BRT2. In addition, further investigations of road geometry, junction arrangements, Park & Ride and halt locations will be undertaken in order to further inform the selection of the preferred route layouts."
            },
            {
                title:"Development of Service Operations",
                text: "Further development and assessment of the route options will involve the preparation of preliminary service operation plans for each option. This task will be undertaken in conjunction with Translink. It will include the review of existing bus services along the network and recommendations on the integration of other feeder/ residual services to support BRT2."
            },
            {
                title:"Further Consultations",
                text: "Further public consultation will be undertaken prior to implementation of the scheme."
            }
        ],
       sliderData: {
         carousel:[
             {
                 image:"The provision of a customer-focused, high quality, integrated public transport system, which is sustainable, provides good value for money, enhances competitiveness, helps sustain economic growth, promotes regional development and contributes to social inclusion."
             }
         ],
        
    },
    carouselOld: [
            {
                image:"Patronage on the BRT1 corridors has shown an increase of some 70% prior to implementation of Belfast Rapid Transit works, now carrying approximately 10 million passengers"
            },
            {
                image: "Unified fares with Metro with a focus on ease of use and great value"
            },
            {
                image: "7-8 minute intervals throughout most of the day"
            },
            {
                image: "25% reduction in public transport journey times"
            }
        ]
    }
  }
};
</script>
